"use strict";
/**
 * 全球时间
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qqsj = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var cache_emutc = null;
/**
 * 全球时间
 */
exports.qqsj = {
    getTime: function (cb) {
        if (cache_emutc) {
            return this.dealTime(cache_emutc);
        }
        else {
            this.getTimeApi(cb);
        }
    },
    /**
     * 读接口时间
     * @param cb
     */
    getTimeApi: function (cb) {
        var that = this;
        $.ajax({
            url: '//cmsjs.eastmoney.com/TimeZone/Default.aspx?type=utctime&ids=41,2,78,53&jn=emutc',
            type: 'GET',
            dataType: 'script'
        })
            .done(function () {
            if (emutc) {
                cache_emutc = emutc;
                var res = that.dealTime(emutc);
                cb && cb(res);
            }
        });
    },
    /**
     * 格式化
     * @param emutc
     * @returns
     */
    dealTime: function (emutc) {
        try {
            var GMT = emutc.GMT;
            // 计算时间差
            var london_timespan = transGTMStringToMinute(GMT[0]) - transGTMStringToMinute(GMT[1]);
            var newyork_timespan = transGTMStringToMinute(GMT[0]) - transGTMStringToMinute(GMT[2]);
            var sydney_timespan = transGTMStringToMinute(GMT[0]) - transGTMStringToMinute(GMT[3]);
            emutc.UTCTIME += 1000;
            var res = {
                beijing: (0, dayjs_1.default)(emutc.UTCTIME).format('MM月DD日 HH:mm:ss') || "",
                london: (0, dayjs_1.default)(emutc.UTCTIME - london_timespan).format('MM月DD日 HH:mm:ss') || "",
                newyork: (0, dayjs_1.default)(emutc.UTCTIME - newyork_timespan).format('MM月DD日 HH:mm:ss') || "",
                sydney: (0, dayjs_1.default)(emutc.UTCTIME - sydney_timespan).format('MM月DD日 HH:mm:ss') || ""
            };
            return res;
        }
        catch (error) {
            return {
                beijing: "",
                london: "",
                newyork: "",
                sydney: ""
            };
        }
    }
};
/**
 * 字符串转成毫秒数
 * @param GMTstring
 */
function transGTMStringToMinute(GMTstring) {
    var gtmlist = GMTstring.split(':');
    var back = Math.abs(parseInt(gtmlist[0])) * 60 * 60 * 1000 + parseInt(gtmlist[1]) * 60 * 1000 + +parseInt(gtmlist[2]) * 1000;
    if (GMTstring.indexOf('-') == 0) { //负值
        return -back;
    }
    return back;
}
